// src/utils/Time.js
import moment from "moment-timezone";

/**
 * Show time in company timezone (table/list views)
 * Example: "13 Dec 2025, 10:00 PM"
 */
export const convertToCompanyTime = (utcString, timezone) => {
  if (!utcString || !timezone) return "—";
  const m = moment.utc(utcString);
  if (!m.isValid()) return "—";
  return m.tz(timezone).format("DD MMM YYYY, hh:mm A");
};


/**
 * Convert UTC → YYYY-MM-DDTHH:mm (correct for datetime-local input)
 * Example: modal edit input fields
 */
export const convertToLocalInput = (utcString, timezone) => {
  if (!utcString || !timezone) return "";

  const m = moment.utc(utcString);
  if (!m.isValid()) return "";

  return m.tz(timezone).format("YYYY-MM-DDTHH:mm");
};


/**
 * Convert datetime-local → UTC (before sending to backend)
 * Backend always stores UTC
 */
export const convertLocalToUTC = (localString, timezone) => {
  if (!localString || !timezone) return null;

  // Parse in company timezone, convert to UTC
  return moment.tz(localString, timezone).utc().format("YYYY-MM-DD HH:mm:ss");
};


export const formatLocalTimeWithoutOffset = (isoString, timezone) => {
  if (!isoString || !timezone) return "—";
  const m = moment.tz(isoString, timezone);
  return m.isValid() ? m.format("DD MMM YYYY, hh:mm A") : "—";
};


export const convertLocalToUTCStrict = (localString, timezone) => {
  if (!localString || !timezone) return null;

  // Normalize: handle both 'T' and space, strip seconds if needed
  let normalized = localString.trim();
  if (normalized.includes(' ')) {
    normalized = normalized.replace(' ', 'T');
  }
  if (normalized.length > 16) {
    normalized = normalized.substring(0, 16); // YYYY-MM-DDTHH:mm
  }

  // ✅ Parse EXPLICITLY as local-in-timezone
  const m = moment.tz(normalized, "YYYY-MM-DDTHH:mm", timezone);
  if (!m.isValid()) {
    console.warn("Invalid datetime:", localString, "in timezone", timezone);
    return null;
  }

  return m.utc().format("YYYY-MM-DD HH:mm:ss");
};


export const convertToLocalInputTaskPage = (utcString, timezone) => {
  if (!utcString || !timezone) return "";
  return moment.utc(utcString).tz(timezone).format("YYYY-MM-DDTHH:mm");
};

export const convertToCompanyTimeTaskPage = (utcString, timezone) => {
  if (!utcString || !timezone) return "—";
  return moment.utc(utcString).tz(timezone).format("DD MMM YYYY, hh:mm A");
};


